import React from 'react';
import { translate } from 'react-i18next';
import SecurityBoxLogo from '../SecurityBoxLogo';

const RestrictedContainer = ({ t }) => {
  setTimeout(() => {
    document.location = 'http://goodwix.com/#1481478485405-5b2d56a2-f3c8';
  }, 5000);

  return (
    <div>
      <SecurityBoxLogo />
      <div
        style={{
          position: 'absolute',
          top: '35%',
          fontSize: '18pt',
          display: 'inline-block',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textAlign: 'center',
          transform: 'translate(-50%, -50%)',
          left: '50%'
        }}
      >
        {t('Service currently is in beta-test state')}
        <br />
        {t('After 5 second you will be redirect to the project site')}
      </div>
    </div>
  );
};

export default translate(['ui'])(RestrictedContainer);



// WEBPACK FOOTER //
// ./components/info/RestrictedContainer.jsx